import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.attributes"))),
      ]),
      _vm._t("default"),
      _c(VBreadcrumbs, {
        staticClass: "pa-0 py-2 text--black",
        attrs: { items: _vm.getBreadcrumbs },
      }),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(
                  VCardTitle,
                  { attrs: { "primary-title": "" } },
                  [
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          {
                            staticClass: "col-md-10 col-xl-8 col-12",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              VContainer,
                              {
                                staticClass: "text-center",
                                attrs: { fluid: "" },
                              },
                              [
                                !_vm.selectedCompany
                                  ? [
                                      _c(
                                        "h3",
                                        { staticClass: "headline mb-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "attributes.search.user_groups_select_company"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm.orgCards.length > 0
                                        ? _c("grid-card-component", {
                                            attrs: {
                                              "custom-cards": _vm.orgCards,
                                            },
                                          })
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "grey--text text-body-1 mt-4",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "attributes.search.user_groups_no_companies"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                    ]
                                  : [
                                      _c(
                                        "h3",
                                        { staticClass: "headline mb-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "attributes.search.user_groups_title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-subtitle-1 mb-6 grey--text",
                                        },
                                        [_vm._v(_vm._s(_vm.companyDisplayName))]
                                      ),
                                      _vm.userGroupCards.length > 0
                                        ? _c("grid-card-component", {
                                            attrs: {
                                              "custom-cards":
                                                _vm.userGroupCards,
                                            },
                                          })
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "grey--text text-body-1 mt-4",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "attributes.search.user_groups_empty"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }